import React, { Suspense } from 'react';

import { Routes, Route } from 'react-router-dom';

import PageLoader from 'components/PageLoader/PageLoader';
import PATHS, { AUTH_PREFIX, INTERNAL_PREFIX } from 'constants/paths';
import { internalRoutes, authRoutes, NestedRoute as RouteType, LoginPage, DashboardPage, Page404 } from 'constants/routes';
import AuthRoute from 'root/AuthRoute/AuthRoute';
import PrivateRoute from 'root/PrivateRoute/PrivateRoute';
import lazyPreload from 'utils/lazyPreload/lazyPreload';

const DocumentsPage = lazyPreload(() => import('pages/DocumentsPage/DocumentsPage'));

const renderer = (routesToRender: RouteType[]) =>
  routesToRender.map(routeConfig => {
    const { path, element: Element, subRoutes } = routeConfig;
    if (subRoutes) {
      const indexRoute = subRoutes.find(({ index }) => index);
      return (
        <Route element={<Element />} key={path} path={path}>
          {indexRoute && <Route element={<indexRoute.element />} index />}
          {renderer(subRoutes)}
        </Route>
      );
    }
    return <Route element={<Element />} key={path} path={path} />;
  });

const Router: React.FC = () => (
  <Suspense fallback={<PageLoader />}>
    <Routes>
      <Route element={<DocumentsPage />} path={PATHS.DOCUMENTS} />
      <Route element={<AuthRoute />} path={AUTH_PREFIX}>
        <Route element={<LoginPage />} index />
        {authRoutes.map(routeConfig => {
          const { path, element: Element } = routeConfig;
          return <Route element={<Element />} key={path} path={path} />;
        })}
      </Route>
      <Route element={<PrivateRoute />} path={INTERNAL_PREFIX}>
        <Route element={<DashboardPage />} index />
        {renderer(internalRoutes)}
      </Route>
      <Route element={<Page404 />} path='*' />
    </Routes>
  </Suspense>
);
export default Router;
